import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Sun, Moon, Users, MagnifyingGlass, SignOut, User,
  CaretDown, CaretUp,
  Briefcase, Storefront, Code, Wrench, Globe, Camera,
  Megaphone, Headset, Book, TreeStructure, ShieldCheck,
  Heartbeat, GraduationCap, Leaf, Coffee, GameController,
  MusicNote, Airplane, Buildings, HandCoins, Flag,
  ChartBar, ChartLine, ChartPie,
  Hammer, Scales, CurrencyDollar, Handshake, Receipt, Tag, Package, Truck, Warehouse, Factory,
  Cpu, Desktop, DeviceMobile, Printer, Microphone, Gear, Terminal, Database, Cloud, Robot, Monitor, WifiHigh, HardDrive, Bug,
  Pen, PenNib, Pencil, Stack, Palette,
  Heart, FirstAidKit, Stethoscope, Pill, ForkKnife, CookingPot, Wine, BeerStein, Barbell, Bicycle, Football, Basketball, Baseball, Waves, Fish, Dog, Cat, PawPrint,
  Tree, Umbrella, SunHorizon, Tent, Campfire,
  Headphones, PaintBrush, FilmStrip, VideoCamera, Guitar, Scissors,
  House, Star, Lightning, Fire, Smiley, Diamond, Crown, Rocket, Broadcast, Newspaper, Bag,
} from '@phosphor-icons/react';
import '../styles/App.css';

/**
 * Status options for client pipeline
 */
const statusOptions = [
  { value: 'prospect', label: 'Prospect' },
  { value: 'active', label: 'Active' },
  { value: 'lost', label: 'Lost' },
  { value: 'archived', label: 'Archived' }
];

/**
 * Sort options for client list
 */
const sortOptions = [
  { value: 'recent', label: 'Recently updated' },
  { value: 'name', label: 'Name' },
  { value: 'tasks', label: 'Most tasks' }
];

const CLIENTS_PER_PAGE = 20;

/**
 * Hand Icon Component
 */
const HandIcon = ({ size = 40 }) => (
  <div
    role="img"
    aria-label="Handy Co Logo"
    style={{
      width: size,
      height: size,
      backgroundColor: 'var(--crm-text, #9CACA6)',
      WebkitMaskImage: 'url(/assets/icons/icon_handyco.svg)',
      WebkitMaskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      WebkitMaskSize: 'contain',
      maskImage: 'url(/assets/icons/icon_handyco.svg)',
      maskRepeat: 'no-repeat',
      maskPosition: 'center',
      maskSize: 'contain',
      flexShrink: 0,
    }}
  />
);

const HandyCoIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 3000 3000" xmlns="http://www.w3.org/2000/svg" style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}>
    <g transform="matrix(4.4244,0,0,4.4244,-763.512,-749.867)">
      <path
        d="M469.35,296.88C471.517,281.367 479.09,270.373 492.07,263.9C501.98,258.97 513.43,258.2 523.51,262.48C538.363,268.787 546.78,279.927 548.76,295.9C548.814,296.312 549.168,296.623 549.583,296.623C549.692,296.623 549.799,296.602 549.9,296.56C556.947,293.6 564,292.783 571.06,294.11C585.51,296.83 599.02,308.88 602.86,323.19C603.66,326.17 604.057,330.753 604.05,336.94C604.05,374.927 604.04,412.843 604.02,450.69C604.02,450.693 604.02,450.696 604.02,450.699C604.02,450.913 604.196,451.089 604.41,451.089C604.515,451.089 604.617,451.046 604.69,450.97C618.84,437.02 639.41,426.89 659.24,427.98C664.66,428.28 664.37,432.59 664.38,437.26C664.5,492.507 664.463,547.753 664.27,603C664.237,611.653 663.75,619.143 662.81,625.47C658.67,653.417 647.713,678.313 629.94,700.16C610.46,724.12 585.973,740.797 556.48,750.19C505.82,766.34 452.23,754.63 412.11,720.14C383.98,695.96 364.99,661.82 359.82,624.7C359.14,619.813 358.8,613.167 358.8,604.76C358.807,538.667 358.797,472.577 358.77,406.49C358.76,390.59 358.14,382.04 364.01,370.82C373.46,352.77 392.95,346.17 412.5,352.32C412.827,352.42 412.997,352.297 413.01,351.95C413.123,346.123 413.227,340.303 413.32,334.49C413.553,319.93 419.647,308.657 431.6,300.67C443.393,292.777 455.83,291.597 468.91,297.13C469.17,297.237 469.317,297.153 469.35,296.88ZM517.16,491.72C520.22,485.287 521.75,479.547 521.75,474.5C521.783,418.06 521.773,361.623 521.72,305.19C521.72,299.22 520.74,294.51 515.91,291.36C511.16,288.25 504.9,288.7 500.67,292.54C498.043,294.92 496.73,297.907 496.73,301.5C496.737,372.253 496.783,442.977 496.87,513.67C496.87,513.671 496.87,513.672 496.87,513.673C496.87,513.882 497.042,514.053 497.25,514.053C497.325,514.053 497.398,514.031 497.46,513.99C506.173,508.437 512.74,501.013 517.16,491.72ZM467.39,336.13C467.34,318.61 442.6,317.07 442.06,335.11C442.007,336.903 441.98,338.7 441.98,340.5C441.827,407.407 441.93,474.247 442.29,541.02C442.29,541.021 442.29,541.022 442.29,541.023C442.29,541.242 442.471,541.423 442.69,541.423C442.753,541.423 442.814,541.408 442.87,541.38L466.85,529.68C467.163,529.527 467.32,529.273 467.32,528.92C467.6,474.647 467.623,410.383 467.39,336.13ZM550.47,480.8C547.46,509.19 529.31,532.05 504.01,544.48C465.437,563.44 426.84,582.383 388.22,601.31C387.913,601.463 387.753,601.713 387.74,602.06C385.87,644.65 409.72,684.7 444.33,708.19C455.69,715.903 468.897,721.473 483.95,724.9C484.197,724.953 484.28,724.86 484.2,724.62C462.16,657.07 506.62,584.84 575.61,571.32C575.97,571.253 576.15,571.037 576.15,570.67C575.977,492.277 575.867,413.887 575.82,335.5C575.8,318.5 551.04,317.5 551,336.5C550.92,379.393 550.91,422.29 550.97,465.19C550.983,472.297 550.817,477.5 550.47,480.8ZM412.72,555.84C412.824,555.79 412.89,555.685 412.89,555.57C412.983,501.41 413.007,447.22 412.96,393C412.953,386.9 410.483,382.7 405.55,380.4C398.13,376.95 387.3,381.33 387.3,390.5C387.273,449.68 387.303,508.76 387.39,567.74C387.394,568.05 387.65,568.303 387.96,568.303C388.05,568.303 388.14,568.281 388.22,568.24L412.72,555.84ZM605.42,598.11C582.667,596.85 562.21,603.087 544.05,616.82C524.537,631.58 512.927,651.053 509.22,675.24C506.7,691.687 508.74,707.213 515.34,721.82C516.053,723.393 517.173,725.14 518.7,727.06C518.888,727.298 519.179,727.433 519.48,727.42C574.07,725.03 618.07,684.3 632.03,632.72C635.1,621.37 635.22,610.51 635.23,598.25C635.263,554.337 635.273,510.413 635.26,466.48C635.256,466.225 635.045,466.018 634.79,466.018C634.702,466.018 634.615,466.043 634.54,466.09C611.48,481.03 606.19,505.64 606.14,531.87C606.107,553.777 606.05,575.687 605.97,597.6C605.97,597.96 605.787,598.13 605.42,598.11Z"
        style={{ fill: 'currentColor', fillRule: 'nonzero' }}
      />
    </g>
  </svg>
);

const CLIENT_ICONS = {
  // Brand
  HandyCo: HandyCoIcon,
  // People & work
  User, Users, Briefcase, Handshake, HandCoins,
  // Business & finance
  Buildings, Storefront, Warehouse, Factory, CurrencyDollar, Receipt, Tag, ChartBar, ChartLine, ChartPie, Scales,
  // Services & trades
  Wrench, Hammer, Scissors, Truck, Package,
  // Tech
  Code, Globe, Cpu, Desktop, DeviceMobile, Monitor, Printer, WifiHigh, HardDrive, Terminal, Database, Cloud, Robot, Gear, Bug,
  // Communication & media
  Megaphone, Headset, Microphone, Broadcast, Newspaper, VideoCamera, Camera, FilmStrip,
  // Creative
  PaintBrush, Palette, Pen, PenNib, Pencil, Guitar, MusicNote, Headphones,
  // Health & wellness
  Heartbeat, Heart, FirstAidKit, Stethoscope, Pill,
  // Food & drink
  ForkKnife, CookingPot, Coffee, Wine, BeerStein,
  // Sports & fitness
  Barbell, Bicycle, Football, Basketball, Baseball, GameController,
  // Nature & outdoors
  Leaf, Tree, Waves, Fish, Dog, Cat, PawPrint, SunHorizon, Umbrella, Tent, Campfire,
  // Education & knowledge
  GraduationCap, Book, Stack,
  // Travel & lifestyle
  Airplane, House, Flag,
  // Misc
  Star, Lightning, Fire, Smiley, Diamond, Crown, Rocket, ShieldCheck, TreeStructure, Bag,
};

const ClientAvatar = ({ client, size = 36 }) => {
  const IconComponent = client?.icon ? CLIENT_ICONS[client.icon] : null;
  const letter = (client?.company || client?.name || '?')[0].toUpperCase();
  return (
    <div className="crm-client-avatar" data-status={client?.status || 'prospect'} style={{ width: size, height: size, fontSize: size * 0.4 }}>
      {IconComponent ? <IconComponent weight="fill" size={size * 0.5} /> : letter}
    </div>
  );
};

/**
 * All Clients Page - Full paginated client list with filters
 */
const AllClients = () => {
  const navigate = useNavigate();

  // Authentication state
  const [sessionToken, setSessionToken] = useState('');
  const [user, setUser] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [authLoading, setAuthLoading] = useState(true);

  // User dropdown menu
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);

  // Data state
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [error, setError] = useState('');

  // Filter & sort state
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState('recent');
  const [searchQuery, setSearchQuery] = useState('');

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);

  // Modal state
  const [showAddModal, setShowAddModal] = useState(false);
  const [clientForm, setClientForm] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    status: 'prospect',
    source: ''
  });

  // Auth headers for API requests
  const authHeaders = useMemo(
    () => (sessionToken ? { 'Authorization': `Bearer ${sessionToken}` } : {}),
    [sessionToken]
  );

  /**
   * Fuzzy search scoring - returns a score (higher = better match)
   * Priority: company name > contact name > email > phone > source > latest thought
   */
  const getSearchScore = useCallback((client, query) => {
    if (!query) return 1;
    const q = query.toLowerCase();
    
    // Check each field with different weights
    const fields = [
      { value: client.company, weight: 100 },
      { value: client.name, weight: 50 },
      { value: client.email, weight: 30 },
      { value: client.phone, weight: 20 },
      { value: client.source, weight: 15 },
      { value: client.latest_thought_text, weight: 10 },
      { value: client.status, weight: 5 }
    ];
    
    let totalScore = 0;
    
    for (const field of fields) {
      if (!field.value) continue;
      const val = field.value.toLowerCase();
      
      // Exact match gets highest score
      if (val === q) {
        totalScore += field.weight * 3;
      }
      // Starts with query
      else if (val.startsWith(q)) {
        totalScore += field.weight * 2;
      }
      // Contains query
      else if (val.includes(q)) {
        totalScore += field.weight;
      }
      // Fuzzy: check if all query chars exist in order
      else {
        let queryIndex = 0;
        for (let i = 0; i < val.length && queryIndex < q.length; i++) {
          if (val[i] === q[queryIndex]) {
            queryIndex++;
          }
        }
        if (queryIndex === q.length) {
          totalScore += field.weight * 0.5;
        }
      }
    }
    
    return totalScore;
  }, []);

  // Filtered and sorted clients
  const filteredClients = useMemo(() => {
    let result = [...clients];
    
    // Filter by search query
    if (searchQuery.trim()) {
      result = result
        .map(c => ({ ...c, _searchScore: getSearchScore(c, searchQuery.trim()) }))
        .filter(c => c._searchScore > 0)
        .sort((a, b) => b._searchScore - a._searchScore);
    }
    
    // Filter by status
    if (statusFilter !== 'all') {
      result = result.filter(c => c.status === statusFilter);
    }
    
    // Sort (only if not searching, as search already sorts by relevance)
    if (!searchQuery.trim()) {
      switch (sortBy) {
        case 'name':
          result.sort((a, b) => (a.company || a.name || '').localeCompare(b.company || b.name || ''));
          break;
        case 'tasks':
          result.sort((a, b) => (b.open_tasks || 0) - (a.open_tasks || 0));
          break;
        case 'recent':
        default:
          result.sort((a, b) => new Date(b.updated_at || 0) - new Date(a.updated_at || 0));
          break;
      }
    }
    
    return result;
  }, [clients, statusFilter, sortBy, searchQuery, getSearchScore]);

  // Paginated clients
  const paginatedClients = useMemo(() => {
    const start = (currentPage - 1) * CLIENTS_PER_PAGE;
    const end = start + CLIENTS_PER_PAGE;
    return filteredClients.slice(start, end);
  }, [filteredClients, currentPage]);

  // Total pages
  const totalPages = useMemo(() => {
    return Math.ceil(filteredClients.length / CLIENTS_PER_PAGE);
  }, [filteredClients.length]);

  /**
   * Check for existing session on mount
   */
  useEffect(() => {
    const checkSession = async () => {
      const storedToken = localStorage.getItem('crm_session');
      const storedUser = localStorage.getItem('crm_user');

      if (!storedToken) {
        setAuthLoading(false);
        navigate('/dashboard');
        return;
      }

      try {
        const res = await fetch('/api/crm/auth/session', {
          headers: { 'Authorization': `Bearer ${storedToken}` }
        });
        const data = await res.json();

        if (res.ok && data.valid) {
          setSessionToken(storedToken);
          setUser(storedUser ? JSON.parse(storedUser) : data.user);
          setAuthenticated(true);
        } else {
          localStorage.removeItem('crm_session');
          localStorage.removeItem('crm_user');
          navigate('/dashboard');
        }
      } catch (err) {
        console.error('Session check error:', err);
        navigate('/dashboard');
      } finally {
        setAuthLoading(false);
      }
    };

    checkSession();
  }, [navigate]);

  /**
   * Load all clients from the API
   */
  const loadClients = useCallback(
    async () => {
      if (!sessionToken) return;
      setLoading(true);
      setError('');
      try {
        const res = await fetch('/api/crm/clients', {
          headers: authHeaders
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'Unable to load clients');
        setClients(data.clients || []);
      } catch (err) {
        setError(err.message || 'Unable to load clients');
      } finally {
        setLoading(false);
      }
    },
    [sessionToken, authHeaders]
  );

  // Load clients on authentication
  useEffect(() => {
    if (authenticated) {
      loadClients();
    }
  }, [authenticated, loadClients]);

  // Reset to page 1 when filter or search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter, sortBy, searchQuery]);

  /**
   * Close user dropdown when clicking outside it
   */
  useEffect(() => {
    if (!userMenuOpen) return;
    const handleOutsideClick = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [userMenuOpen]);

  /**
   * Handle sign out
   */
  const handleSignOut = () => {
    localStorage.removeItem('crm_session');
    localStorage.removeItem('crm_user');
    navigate('/dashboard');
  };

  /**
   * Create a new client
   */
  const handleCreateClient = async (e) => {
    e.preventDefault();
    if (!clientForm.company.trim()) {
      setError('Company name is required');
      return;
    }
    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/crm/clients', {
        method: 'POST',
        headers: { ...authHeaders, 'Content-Type': 'application/json' },
        body: JSON.stringify(clientForm)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Unable to add client');

      setClientForm({
        name: '',
        company: '',
        email: '',
        phone: '',
        status: 'prospect',
        source: ''
      });
      setShowAddModal(false);
      navigate(`/dashboard/${data.client.id}`);
    } catch (err) {
      setError(err.message || 'Unable to add client');
    } finally {
      setLoading(false);
    }
  };

  // Theme state
  const [theme, setTheme] = useState(() => localStorage.getItem('crm_theme') || 'dark');
  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem('crm_theme', next);
  };

  // Loading state
  if (authLoading) {
    return (
      <div className={`crm-page ${theme === 'light' ? 'crm-light' : ''}`}>
        <div className="crm-login-wrapper">
          <div className="crm-login">
            <HandIcon size={80} />
            <div className="crm-auth-loading">
              <div className="crm-spinner" />
              <p>Loading...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Not authenticated - redirect handled in useEffect
  if (!authenticated) {
    return null;
  }

  return (
    <div className={`crm-page ${theme === 'light' ? 'crm-light' : ''}`}>
      {/* Header */}
      <header className="crm-header">
        <div className="crm-header-brand" onClick={() => navigate('/dashboard')}>
          <HandIcon size={36} />
          <span className="crm-header-title">
            <span className="crm-header-wordmark">HANDY CO</span>
          </span>
        </div>
        <nav className="crm-header-nav">
          <button className="crm-nav-link" onClick={() => navigate('/dashboard')}>Overview</button>
          <button className="crm-nav-link active" onClick={() => navigate('/dashboard/all')}>Clients</button>
          <button className="crm-nav-link" onClick={() => navigate('/dashboard/tasks')}>Tasks</button>
          <button className="crm-nav-link" onClick={() => navigate('/dashboard/thoughts')}>Thoughts</button>
          <button className="crm-nav-link" onClick={() => navigate('/ds')}>Design Systems</button>
        </nav>
        <div className="crm-header-actions">
          <button
            className="crm-button ghost"
            onClick={() => loadClients()}
            disabled={loading}
          >
            {loading ? 'Syncing…' : 'Refresh'}
          </button>
          <button className="crm-button ghost crm-theme-toggle" onClick={toggleTheme} aria-label="Toggle theme">
            {theme === 'dark' ? <Sun weight="fill" size={18} /> : <Moon weight="fill" size={18} />}
          </button>
          {user && (
            <div className="crm-user-menu-wrap" ref={userMenuRef}>
              <button
                className="crm-button ghost crm-user-btn"
                onClick={() => setUserMenuOpen((o) => !o)}
                aria-haspopup="true"
                aria-expanded={userMenuOpen}
              >
                {user.picture && (
                  <img src={user.picture} alt="" className="crm-user-avatar" />
                )}
                <span className="crm-user-name">{user.name?.split(' ')[0] || 'Account'}</span>
                <span className="crm-user-chevron">{userMenuOpen ? <CaretUp weight="fill" size={12} /> : <CaretDown weight="fill" size={12} />}</span>
              </button>
              {userMenuOpen && (
                <div className="crm-user-dropdown">
                  <div className="crm-user-dropdown-header">
                    <span className="crm-user-dropdown-name">{user.name}</span>
                    <span className="crm-user-dropdown-email">{user.email}</span>
                  </div>
                  <div className="crm-user-dropdown-divider" />
                  <button
                    className="crm-user-dropdown-item"
                    onClick={() => { setUserMenuOpen(false); navigate('/dashboard/profile'); }}
                  >
                    <span className="crm-user-dropdown-icon"><User weight="fill" size={14} /></span> Profile
                  </button>
                  <button
                    className="crm-user-dropdown-item crm-user-dropdown-item--danger"
                    onClick={() => { setUserMenuOpen(false); handleSignOut(); }}
                  >
                    <span className="crm-user-dropdown-icon"><SignOut weight="fill" size={14} /></span> Sign out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="crm-main crm-main-full">
        {/* Error Display */}
        {error && <div className="crm-error" style={{ marginBottom: 24 }}>{error}</div>}

        {/* Header */}
        <div className="crm-list-header">
          <div>
            <h2 className="crm-section-title">All clients</h2>
            <p className="crm-section-subtitle">
              {filteredClients.length} {filteredClients.length === 1 ? 'client' : 'clients'}
              {statusFilter !== 'all' && ` · ${statusFilter}`}
            </p>
          </div>
          
          <div className="crm-list-header-actions">
            <button className="crm-button primary" onClick={() => setShowAddModal(true)}>
              + New
            </button>
            {/* Search and Filters */}
            <div className="crm-search-filters">
              <div className="crm-search-wrapper">
                <MagnifyingGlass weight="fill" size={16} className="crm-search-icon" />
                <input
                  className="crm-search-input"
                  type="text"
                  placeholder="Search clients..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                {searchQuery && (
                  <button 
                    className="crm-search-clear"
                    onClick={() => setSearchQuery('')}
                    aria-label="Clear search"
                  >
                    ×
                  </button>
                )}
              </div>
              <div className="crm-filters">
                <select
                  className="crm-filter-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="all">All statuses</option>
                  {statusOptions.map((s) => (
                    <option key={s.value} value={s.value}>{s.label}</option>
                  ))}
                </select>
                <select
                  className="crm-filter-select"
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  disabled={!!searchQuery.trim()}
                >
                  {sortOptions.map((s) => (
                    <option key={s.value} value={s.value}>Sort: {s.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* Client List */}
        <div className="crm-client-list">
          {loading && paginatedClients.length === 0 && (
            <div className="crm-empty-state">
              <div className="crm-spinner" />
              <p className="crm-empty-title">Loading clients…</p>
            </div>
          )}
          {!loading && filteredClients.length === 0 && clients.length > 0 && (
            <div className="crm-empty-state">
              <div className="crm-empty-icon"><MagnifyingGlass weight="fill" size={32} /></div>
              <p className="crm-empty-title">No matches</p>
              <p className="crm-empty-desc">Try a different search or filter.</p>
            </div>
          )}
          {!loading && clients.length === 0 && (
            <div className="crm-empty-state">
              <div className="crm-empty-icon"><Users weight="fill" size={32} /></div>
              <p className="crm-empty-title">No clients yet</p>
              <p className="crm-empty-desc">Add your first client to get started.</p>
              <button className="crm-button primary" onClick={() => setShowAddModal(true)}>+ New client</button>
            </div>
          )}
          {paginatedClients.map((client) => (
            <button
              key={client.id}
              className={`crm-client-row ${client.status === 'archived' ? 'crm-client-row--archived' : ''}`}
              data-status={client.status || 'prospect'}
              onClick={() => navigate(`/dashboard/${client.id}`, { state: { from: '/dashboard/all' } })}
            >
              <ClientAvatar client={client} />
              <div className="crm-client-info">
                <p className="crm-client-company">{client.company || 'No company'}</p>
                <p className="crm-client-contact">{client.name || 'No contact'}{client.email ? ` · ${client.email}` : ''}</p>
              </div>
              <div className="crm-client-badges">
                <span className="crm-chip" data-status={client.status || 'prospect'}>
                  {client.status || 'prospect'}
                </span>
                {(client.open_tasks || 0) > 0 && (
                  <span className="crm-task-count">
                    {client.open_tasks} {client.open_tasks === 1 ? 'task' : 'tasks'}
                  </span>
                )}
              </div>
            </button>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="crm-pagination">
            <button
              className="crm-button ghost"
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
            >
              ← Previous
            </button>
            <span className="crm-pagination-info">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="crm-button ghost"
              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              disabled={currentPage === totalPages}
            >
              Next →
            </button>
          </div>
        )}
      </main>

      {/* Add Client Modal */}
      {showAddModal && (
        <div className="crm-modal-backdrop" onClick={() => setShowAddModal(false)}>
          <div className="crm-modal" onClick={(e) => e.stopPropagation()}>
            <div className="crm-card-head">
              <h3>New client</h3>
              <button className="crm-button ghost" onClick={() => setShowAddModal(false)}>
                Cancel
              </button>
            </div>
            <form className="crm-form" onSubmit={handleCreateClient}>
              <input
                className="crm-input"
                placeholder="Company *"
                value={clientForm.company}
                onChange={(e) => setClientForm({ ...clientForm, company: e.target.value })}
                autoFocus
              />
              <input
                className="crm-input"
                placeholder="Contact name"
                value={clientForm.name}
                onChange={(e) => setClientForm({ ...clientForm, name: e.target.value })}
              />
              <div className="crm-row-split">
                <input
                  className="crm-input"
                  placeholder="Email"
                  type="email"
                  value={clientForm.email}
                  onChange={(e) => setClientForm({ ...clientForm, email: e.target.value })}
                />
                <input
                  className="crm-input"
                  placeholder="Phone"
                  value={clientForm.phone}
                  onChange={(e) => setClientForm({ ...clientForm, phone: e.target.value })}
                />
              </div>
              <div className="crm-row-split">
                <select
                  className="crm-select-min"
                  value={clientForm.status}
                  onChange={(e) => setClientForm({ ...clientForm, status: e.target.value })}
                >
                  {statusOptions.map((s) => (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  ))}
                </select>
                <input
                  className="crm-input"
                  placeholder="Source"
                  value={clientForm.source}
                  onChange={(e) => setClientForm({ ...clientForm, source: e.target.value })}
                />
              </div>
              {error && <div className="crm-error">{error}</div>}
              <div className="crm-modal-actions">
                <button
                  className="crm-button ghost"
                  type="button"
                  onClick={() => setShowAddModal(false)}
                >
                  Cancel
                </button>
                <button className="crm-button primary" type="submit" disabled={loading}>
                  {loading ? 'Creating…' : 'Create client'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AllClients;
